window._genesys = {
  widgets: {
    webchat: {
      transport: {
        type: 'purecloud-v2-sockets',
        dataURL: 'https://api.mypurecloud.com',
        deploymentKey : '',
        orgGuid : '88ba3b82-9183-40f6-8bbe-fed30be9e44b',
        interactionData: {
          routing: {
            targetType: 'QUEUE',
            targetAddress: 'EverFi - English Chat',
            priority: 2
          }
        }
      }
    },
    main: {
      lang: 'en',
      i18n: {
        en: {},
        es: {}
      }
    }
  }
};